export default function SearchingAnimation() {
  return (
    <div className='flex justify-center items-center h-32'>
      <div className='flex items-center space-x-2'>
        <span className='text-lg font-medium'>Searching</span>
        <div className='flex space-x-1'>
          <div
            className='w-2 h-2 bg-blue-500 rounded-full animate-bounce'
            style={{ animationDelay: '0ms' }}
          ></div>
          <div
            className='w-2 h-2 bg-blue-500 rounded-full animate-bounce'
            style={{ animationDelay: '150ms' }}
          ></div>
          <div
            className='w-2 h-2 bg-blue-500 rounded-full animate-bounce'
            style={{ animationDelay: '300ms' }}
          ></div>
        </div>
      </div>
    </div>
  );
}
